import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { useEffect, useState } from "react";

function InputSearch({
	placeholder = "Search",
	style,
	setSearchValue,
	delay = 300,
}: {
	placeholder?: string;
	style?: React.CSSProperties;
	setSearchValue: (value: string) => void;
	delay?: number;
}) {
	const [inputValue, setInputValue] = useState("");

	useEffect(() => {
		const timer = setTimeout(() => {
			setSearchValue(inputValue);
		}, delay);

		return () => clearTimeout(timer);
	}, [inputValue, setSearchValue, delay]);

	const defaultProps = {
		className: "input-clearable-panel",
		allowClear: true,
		prefix: <SearchOutlined />,
	};
	return (
		<Input
			{...defaultProps}
			placeholder={placeholder}
			style={{ maxWidth: "265px", ...style }}
			value={inputValue}
			onPressEnter={(e: React.KeyboardEvent<HTMLInputElement>) => {
				setSearchValue(e.currentTarget.value);
				e.currentTarget.blur();
			}}
			onChange={(e) => {
				setInputValue(e.target.value);
			}}
		/>
	);
}

export default InputSearch;
